import React from 'react';
import { useState, useEffect } from 'react';
import axios from 'axios';
import EpisodeList from '../components/EpisodeList';
import SwimLane from '../components/SwimLane';
import OriginalSeries from '../components/OriginalSeries';
import collections from '../data/Collections';

import HeroVideo from '../components/HeroVideo'
import HeroPlayButton from '../components/HeroPlayButton'
import HeroInfoButton from '../components/HeroInfoButton'
import HomeFooter from '../components/HomeFooter'
import ModalVideoInfo from '../components/ModalVideoInfo'
import SwimLaneEmptyState from '../components/SwimLaneEmptyState'
import SwimLaneFiltered from '../components/SwimLaneFiltered'
import SwimLaneOriginalSeries from '../components/SwimLaneOriginalSeries'

import { Providers, ProviderState } from '@microsoft/mgt-element';

import { Login } from '@microsoft/mgt-react';

import sha1 from 'crypto-js/sha1';



function useIsSignedIn(): [boolean] {
  const [isSignedIn, setIsSignedIn] = useState(false);

  useEffect(() => {
    const updateState = () => {
      const provider = Providers.globalProvider;
      setIsSignedIn(provider && provider.state === ProviderState.SignedIn);
    };

    Providers.onProviderUpdated(updateState);
    updateState();

    return () => {
      Providers.removeProviderUpdatedListener(updateState);
    }

  }, []);

  return [isSignedIn];
}

function Home() {

  const [isSignedIn] = useIsSignedIn();

    const widgetId = "_1922831";
  const appTokenId = "1_sw1ywh3f";
  const appTokenValue = "77ed7f15a6ce2a399fb939cc6a4bb288";
  //const sessionUserId = "lance.clack@adp.com";

  //const playlistIdFilter = "1_sxzohcku,1_bv779c80,1_1sa9fr0z,1_t58lg6vo,1_8kmv4ads,1_b1rth3f1,1_z1oh8ikk,1_x8xhe2lb,1_7v9rye8c,1_cn52itun,1_1twn39ze,1_den2ighe,1_8pslyeh9,1_etj6a8wi,1_o18uslgx,1_e3nh1fws,1_obrrq4wx,1_ttnnf5p6,1_fc0bozy2,1_2ucze55f,1_dokkeujm,1_sr973vbx,1_frojej82,1_92xlit3i,1_sopda4fd,1_rx8esl23,1_mqftifgq,1_4wlpkuxp,1_wziofwq1,1_19bjuagq,1_1ecn6mbt,1_0gmhccos,1_m4764auh,1_96onzy8c,1_1d2ujv9u,1_o7bzs7af,1_w1qtb15f,1_7lp10jzu,1_m75ds47v,1_6ipvl792,1_p2b3zuue,1_2d8t8b3s,1_78eg4g7b,1_i2ksdzjt,1_f4p17xa0,1_mr7yvgsl,1_7gyugv9b,1_r0rgpjp7,1_1kueex7i,1_ao13z6kl,1_8krfol12,1_5t9zu1ww,1_m14m0wrv,1_9gvxxk77,1_peqar7zu,1_artiiqrc";
  const playlistIdFilterA = "1_sxzohcku,1_bv779c80,1_1sa9fr0z,1_t58lg6vo,1_8kmv4ads,1_b1rth3f1,1_z1oh8ikk,1_x8xhe2lb,1_cn52itun,1_1twn39ze,1_den2ighe,1_8pslyeh9,1_etj6a8wi,1_o18uslgx,1_e3nh1fws,1_fc0bozy2,1_2ucze55f,1_dokkeujm,1_sr973vbx,1_frojej82,1_92xlit3i,1_sopda4fd,1_rx8esl23,1_mqftifgq,1_4wlpkuxp,1_19bjuagq,1_1ecn6mbt,1_0gmhccos,1_m4764auh,1_96onzy8c,1_1d2ujv9u,1_o7bzs7af,1_w1qtb15f,1_7lp10jzu,1_m75ds47v,1_6ipvl792,1_p2b3zuue,1_2d8t8b3s,1_65478lqq,1_7u7qvf0t,1_ny1q2he0,1_lktwp2cj,1_6omkydpy,1_zxe6o4nd,1_dugabqu6,1_jjp0d33f,1_s6l2fip3,1_d607tjwf,1_6hraeqlr,1_9u9zq467,1_yr0kij7c,1_kfmo6fxe,1_s3qus6as,1_fk0xcnkw,1_pe9qu3yc,1_29t57a89,1_z39lwj0s,1_kte6x9ek"; // Do not add more
  const playlistIdFilterB = "1_78eg4g7b,1_i2ksdzjt,1_f4p17xa0,1_mr7yvgsl,1_7gyugv9b,1_r0rgpjp7,1_1kueex7i,1_ao13z6kl,1_8krfol12,1_5t9zu1ww,1_m14m0wrv,1_9gvxxk77,1_peqar7zu,1_artiiqrc,1_0urc0pe9,1_nbr391zn,1_yoj3yhob,1_lxvj66bu,1_8w3uqiru,1_3tkqxd53,1_ignr0wfy,1_0wdr77f4,1_wziofwq1,1_1dqq3i3q,1_eezw6ruy,1_7v4cs7ys,1_zzsi43mt,1_452bqkf7,1_vrxkarf4,1_28z24ujp,1_qail1b0a,1_wiw4aodb,1_qdl0z86g,1_cofxfri9,1_53t2e0we,1_836al8k3,1_21t3hbby,1_rqxx8q3n,1_ttnnf5p6,1_xmgqa5md,1_t48p73pf,1_smaih0hc,1_ackahimb,1_68m1jxbm,1_10v7xxn9,1_18m46wf5,1_d8dmmk65,1_4rfxn3hl,1_6606nmbn,1_3hzok3na,1_kcwdr1a7,1_zkmxgyz1,1_e1jqtqi0,1_7o1vd03m,1_r9b3ltp2,1_brvs5upk,1_ywfiz9n7,1_yty4zrw3,1_iwadzkjb,1_1v82lio0,1_h7rzk7r2,1_jpu5lz1w,1_c0vm7y6t,1_txhp4pvh,1_e130aq62,1_111sx02n,1_lje5rhoj,1_cdu7tyjf,1_o7gl42b9,1_bcxg2fcd,1_f8vh3ttn,1_w4s78qh5,1_mae1eoub,1_vnjn6ky7,1_euo73i1r,1_aia4q1r8,1_zqxndsaj,1_ldgjp6zz,1_h4l5u8q9";
  const newPlaylistIds = "1_sxzohcku,1_bv779c80,1_1sa9fr0z,1_t58lg6vo,1_8kmv4ads,1_b1rth3f1,1_z1oh8ikk,1_x8xhe2lb,1_cn52itun,1_1twn39ze,1_den2ighe,1_8pslyeh9,1_etj6a8wi,1_o18uslgx,1_e3nh1fws,1_fc0bozy2,1_2ucze55f,1_dokkeujm,1_sr973vbx,1_frojej82,1_92xlit3i,1_sopda4fd,1_rx8esl23,1_mqftifgq,1_4wlpkuxp,1_19bjuagq,1_1ecn6mbt,1_0gmhccos,1_m4764auh,1_96onzy8c,1_1d2ujv9u,1_o7bzs7af,1_w1qtb15f,1_7lp10jzu,1_m75ds47v,1_6ipvl792,1_p2b3zuue,1_2d8t8b3s,1_65478lqq,1_7u7qvf0t,1_ny1q2he0,1_lktwp2cj,1_6omkydpy,1_zxe6o4nd,1_dugabqu6,1_jjp0d33f,1_s6l2fip3,1_d607tjwf,1_6hraeqlr,1_9u9zq467,1_yr0kij7c,1_kfmo6fxe,1_s3qus6as,1_fk0xcnkw,1_pe9qu3yc,1_29t57a89,1_z39lwj0s,1_kte6x9ek,1_78eg4g7b,1_i2ksdzjt,1_f4p17xa0,1_mr7yvgsl,1_7gyugv9b,1_r0rgpjp7,1_1kueex7i,1_ao13z6kl,1_8krfol12,1_5t9zu1ww,1_m14m0wrv,1_9gvxxk77,1_peqar7zu,1_artiiqrc,1_0urc0pe9,1_nbr391zn,1_yoj3yhob,1_lxvj66bu,1_8w3uqiru,1_3tkqxd53,1_ignr0wfy,1_0wdr77f4,1_wziofwq1,1_1dqq3i3q,1_eezw6ruy,1_7v4cs7ys,1_zzsi43mt,1_452bqkf7,1_vrxkarf4,1_28z24ujp,1_qail1b0a,1_wiw4aodb,1_qdl0z86g,1_cofxfri9,1_53t2e0we,1_836al8k3,1_21t3hbby,1_rqxx8q3n,1_ttnnf5p6,1_xmgqa5md,1_t48p73pf,1_smaih0hc,1_ackahimb,1_68m1jxbm,1_10v7xxn9,1_18m46wf5,1_d8dmmk65,1_4rfxn3hl,1_6606nmbn,1_3hzok3na,1_kcwdr1a7,1_zkmxgyz1,1_e1jqtqi0,1_7o1vd03m,1_r9b3ltp2,1_brvs5upk,1_ywfiz9n7,1_yty4zrw3,1_iwadzkjb,1_1v82lio0,1_h7rzk7r2,1_jpu5lz1w,1_c0vm7y6t,1_txhp4pvh,1_e130aq62,1_111sx02n,1_lje5rhoj,1_cdu7tyjf,1_o7gl42b9,1_bcxg2fcd,1_f8vh3ttn,1_w4s78qh5,1_mae1eoub,1_vnjn6ky7,1_euo73i1r,1_aia4q1r8,1_zqxndsaj,1_ldgjp6zz,1_h4l5u8q9,1_qxnq2pxt,1_2np7r88z,1_cu2z5hln,1_5l03lth2,1_qhk3xnga,1_mclc89bu,1_m6eegjuz,1_jhwiy5tv,1_s3src5uf,1_eqgx04va,1_gi0h7nwn";


  const [kalturaSession, setKalturaSession] = useState("");
  const [playlists, setPlaylists] = useState([]);
  const [media, setMedia] = useState([]);

  const [topVideos, setTopVideos] = useState([]);

  const [allPlaylistIds, setAllPlaylistIds] = useState([]);

  const [allPlaylistContent, setAllPlaylistContent] = useState([]);

  const [selectedCollection, setSelectedCollection] = useState(collections[0]);
  const [selectedEpisodeId, setSelectedEpisodeId] = useState("");

  const [currentUsername, setCurrentUsername] = useState("default.user@adp.com");


  const chunkArray = (arr, size) => 
    arr.reduce((acc, _, i) =>
      i % size === 0 ? [...acc, arr.slice(i, i + size)] : acc
    , []);

  const getMedia = async (ks, playlistArray, mediaIds) => {
    //const mediaIds = playlistArray;

    const chunks = chunkArray(mediaIds, 400);

    const allMediaObjects = [];

    for (const ids of chunks) {
      const res = await axios.post('https://www.kaltura.com/api_v3/service/media/action/list?ks=' + ks + '&format=1&pager[objectType]=KalturaPager&pager[pageSize]=500&filter[objectType]=KalturaMediaEntryFilter&filter[idIn]=' + ids);
      allMediaObjects.push(...res.data.objects);
    };

    return allMediaObjects;
  }

  const getPlaylists = async (ks) => {
    //console.log('getPlaylists called');
    const res = await axios.post('https://www.kaltura.com/api_v3/service/playlist/action/list?ks=' + ks + '&format=1&filter[objectType]=KalturaMediaEntryFilter&filter[idIn]=' + newPlaylistIds + '&filter[categoriesFullNameIn]=Sales Learning Plus&pager[objectType]=KalturaPager&pager[pageSize]=500');

    const playlists = res.data.objects;

    const playlistIds = playlists.flatMap(pl =>
      pl.playlistContent.split(",")
    );

    //console.log('playlistIds: ' + playlistIds);

    const media = await getMedia(ks, playlists, playlistIds);

    return { playlists, media };
  }

  const startWidgetSession = async () => {

    if(isSignedIn) {
      //console.log('User IS signed in')
      axios.post('https://www.kaltura.com/api_v3/service/session/action/startWidgetSession?widgetId=_1922831&format=1')
    .then(res => {
      const json = res.data;
      //getTokenHash(json["ks"]);
      //console.log('startWidgetSession:' + json["ks"]);
      const stringToHash = json["ks"] + appTokenValue;
      const hashed = sha1(stringToHash);
      startAppTokenSession(json["ks"], hashed);
    })
    } else {
      //console.log('User IS NOT signed in')
    }

    // axios.post('https://www.kaltura.com/api_v3/service/session/action/startWidgetSession?widgetId=_1922831&format=1')
    // .then(res => {
    //   const json = res.data;
    //   //getTokenHash(json["ks"]);
    //   ////console.log('startWidgetSession:' + json["ks"]);
    //   const stringToHash = json["ks"] + appTokenValue;
    //   const hashed = sha1(stringToHash);
    //   startAppTokenSession(json["ks"], hashed);
    // })
  }

  const getTokenHash = async (ks) => {
    const headers = { 
        'Access-Control-Allow-Origin': '*'
    };
    axios.post('https://23e5gbqo53.execute-api.us-east-1.amazonaws.com/test/gethash?text=' + ks + appTokenValue, { headers })
    .then(res => {
      const json = res.data;
      ////console.log('getTokenHash:' + json["hashed"]);
      startAppTokenSession(ks, json["hashed"]);
      
    })
  }

  // const startAppTokenSession = async (ks, tokenHash) => {
  //   //console.log('starting app token session for ' + currentUsername);
  //   axios.post('https://www.kaltura.com/api_v3/service/apptoken/action/startSession?ks=' + ks + '&id=' + appTokenId + '&tokenHash=' + tokenHash + '&userId=' + currentUsername + '&format=1')
  //   .then(res => {
  //     const json = res.data;
  //     setKalturaSession(json["ks"]);
  //     //getPlaylists(json["ks"]);
  //     const { playlists, media } = await getPlaylists(ks);
  //   })
  // }

  const startAppTokenSession = async (ks, tokenHash) => {
    //console.log('starting app token session for ' + currentUsername);
    const res = await axios.post('https://www.kaltura.com/api_v3/service/apptoken/action/startSession?ks=' + ks + '&id=' + appTokenId + '&tokenHash=' + tokenHash + '&userId=' + currentUsername + '&format=1');

    const json = res.data

    setKalturaSession(json["ks"]);

    const { playlists, media } = await getPlaylists(json["ks"]);

    setPlaylists(playlists);
    setMedia(media);

    //getPlaylists(json["ks"]);
  }

  


  // const getPlaylists = async (ks) => {
  //   axios.post('https://www.kaltura.com/api_v3/service/playlist/action/list?ks=' + ks + '&format=1&filter[objectType]=KalturaMediaEntryFilter&filter[idIn]=' + playlistIdFilterA + '&filter[categoriesFullNameIn]=Sales Learning Plus&pager[objectType]=KalturaPager&pager[pageSize]=500')
  //   .then(res => {
  //     const json = res.data;
  //     let playlistContent = json["objects"].flatMap((pl) => pl["playlistContent"].split(','));
  //     getMedia(ks, json["objects"], playlistContent)
  //   })
  // }

  // const getPlaylists = async (ks) => {
  //   axios.post('https://www.kaltura.com/api_v3/service/playlist/action/list?ks=' + ks + '&format=1&filter[objectType]=KalturaMediaEntryFilter&filter[idIn]=' + playlistIds + '&filter[categoriesFullNameIn]=Sales Learning Plus&pager[objectType]=KalturaPager&pager[pageSize]=500')
  //   .then(res => {
  //     const json = res.data;
  //     let playlistContent = json["objects"].flatMap((pl) => pl["playlistContent"].split(','));
  //     //getMedia(ks, json["objects"], playlistContent)
  //     //console.log('getPlaylists: playlistContent' + playlistContent);
  //   })

  //   //const media = await getMedia(ks, json["objects"], playlistContent);
  // }

  

  // const getMedia = async (ks, playlistArray, playlistContent) => {
  //   const mediaIds = playlistArray;
  //   //console.log(mediaIds);
  //   //console.log(playlistContent);
  //   //const chunks = chunkArray(playlistArray, 500);
  //   const chunks = chunkArray(playlistContent, 400);

  //   const allMediaObjects = [];

  //   for (const ids of chunks) {
  //     //console.log('chunks ids: ' + ids);
  //     const res = await axios.post('https://www.kaltura.com/api_v3/service/media/action/list?ks=' + ks + '&format=1&pager[objectType]=KalturaPager&pager[pageSize]=500&filter[objectType]=KalturaMediaEntryFilter&filter[idIn]=' + ids);
  //     //console.log(res);
  //     allMediaObjects.push(...res.data.objects);
  //   };

  //   //return allMediaObjects;
  //   //console.log(allMediaObjects);
  //   console.log('allMedia: ' + allMediaObjects.length);
  //   setMedia(allMediaObjects);
  //   console.log('getMedia: state set attempted');
    
  // }

  // const getMedia = async (ks, playlistArray, playlistContent) => {
  //   axios.post('https://www.kaltura.com/api_v3/service/media/action/list?ks=' + ks + '&format=1&pager[objectType]=KalturaPager&pager[pageSize]=500&filter[objectType]=KalturaMediaEntryFilter&filter[idIn]=' + playlistContent)
  //   .then(res => {
  //     const json = res.data;
  //     getMorePlaylists(ks, playlistArray, json["objects"], playlistContent);
  //   })
  // }



  // const getMorePlaylists = async (ks, playlistArray, mediaArray, p) => {
  //   axios.post('https://www.kaltura.com/api_v3/service/playlist/action/list?ks=' + ks + '&format=1&filter[objectType]=KalturaMediaEntryFilter&filter[idIn]=' + playlistIdFilterB + '&filter[categoriesFullNameIn]=Sales Learning Plus&pager[objectType]=KalturaPager&pager[pageSize]=500')
  //   .then(res => {
  //     const json = res.data;
  //     setPlaylists(playlistArray.concat(json["objects"]));
  //     let playlistContent = json["objects"].flatMap((pl) => pl["playlistContent"].split(','));
  //     setAllPlaylistContent(p.concat(playlistContent));
  //     getMoreMedia(ks, mediaArray, playlistContent)
  //   })
  // }

  // const getMoreMedia = async (ks, mediaArray, morePlaylistContent) => {
  //   //console.log('Getting more media...')
  //   axios.post('https://www.kaltura.com/api_v3/service/media/action/list?ks=' + ks + '&format=1&pager[objectType]=KalturaPager&pager[pageSize]=500&filter[objectType]=KalturaMediaEntryFilter&filter[idIn]=' + morePlaylistContent)
  //   .then(res => {
  //     const json = res.data;
  //     //console.log("Media A:" + mediaArray.length)
  //     //console.log("Media B:" + json["objects"].length)
  //     let allMedia = mediaArray.concat(json["objects"]);
  //     //setMedia(json["objects"]);
  //     setMedia(allMedia);
  //   })
  // }

  function formatDateToYYYYMMdd(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}${month}${day}`;
  }

  const getTopVideos = async (ks) => {
    const today = new Date();
    const thirtyDaysAgo = new Date(today);
    thirtyDaysAgo.setDate(today.getDate() - 30);
    const yesterday = new Date(today)
    yesterday.setDate(today.getDate() - 1);
    const formattedFromDate = formatDateToYYYYMMdd(thirtyDaysAgo);
    const formattedToDate = formatDateToYYYYMMdd(yesterday);
    axios.post('https://www.kaltura.com/api_v3/service/report/action/getTable?ks=' + ks + '&format=1&reportType=1&pager[objectType]=KalturaPager&pager[pageSize]=20&pager[pageIndex]=1&reportInputFilter[objectType]=KalturaReportInputFilter&reportInputFilter[domainIn]=www.slplus.tv&reportInputFilter[fromDay]=' + formattedFromDate + '&reportInputFilter[toDay]=' + formattedToDate)
    .then(res => {
      const json = res.data;
      //setMedia(json["objects"]);
      ////console.log(json["objects"]);
      //console.log('getTopVideos: ' + json);
      getPopularVideos(json["data"]);
    })
  }  

  function getPlaylistWithId(id) {
    var playlist = playlists.find(pl => {
        return pl.id === id
    });
    ////console.log(playlist);
    return playlist;
  }

  function getPlaylistContent(playlistContent) {
    const idArray = playlistContent.split(',');

    var playlistMedia = media.filter(function (ep) {
        return idArray.includes(ep.id);
    });

    return playlistMedia;
  }

  function filteredMedia() {
    // Get only media that belongs to a playlist (this is how we get only episodes of shows, and no orphans).
      return media.filter(function (m) {
          return allPlaylistContent.includes(m.id);
      })
  }

  function getMediaWithId(id) {
    //console.log('DEBUG Media Id: ' + id);
        var episode = media.find(ep => {
            return ep.id === id
        });

        ////console.log(episode);
        return episode;
    }

  function getCollectionContent() {
    // gets content from all playlists in a collection

    var c = collections.find(obj => {
      return obj.name === "Leader Updates"
    })

    ////console.log('Testing getting collection: ' + c.name)

  }

  function getNewContent() {

    var testRecentMedia = []

    for (let i = 0; i < collections.length; i++) {
      let playlists = collections[i]["playlists"];
      //console.log('getNewContent: ' + playlists);
      let playlistId = playlists[playlists.length - 1]["playlistId"];

      let playlistContent = getPlaylistWithId(playlistId)["playlistContent"].split(',');
      let mediaId = playlistContent[playlistContent.length - 1];
      
      testRecentMedia.push(getMediaWithId(mediaId));
    }

    let sortedArr = testRecentMedia.sort((a, b) => {
      let aDate = new Date(Number(a["createdAt"]) * 1000);
      let bDate = new Date(Number(b["createdAt"]) * 1000);
      if (aDate > bDate) {
        return -1;
      }
    });
    //console.log('getNewContent: ' + sortedArr);
    //return sortedArr.slice(0,10);
    //return testRecentMedia;
    return sortedArr;
  }

  function getPopularVideos(csvData) {

    //console.log('getPopularVideos: ' + csvData);
    if (media.length > 0) {

    const rows = csvData.split(';');
    rows.pop();

    const popularEpisodes = [];

    rows.forEach((row) => {
      const columns = row.split(',');
      const firstColumnValue = columns[0].trim();

      popularEpisodes.push(getMediaWithId(firstColumnValue));
    });
    //console.log('getPopularVideos: ' + popularEpisodes.length);
    setTopVideos(popularEpisodes);
    }
  }

  function getPopularContent() {
    let sortedArr = filteredMedia().sort((a, b) => {
      let aViews = new Number(a["views"]);
      let bViews = new Number(b["views"]);
      if (aViews> bViews) {
        return -1;
      }
    });

    return sortedArr.slice(0,10);
  }

  function getPlaylistForEpisode(episodeId) {
      var newArr = playlists.filter(function (pl) {
          return pl["playlistContent"].includes(episodeId);
      });

      //return newArr.length > 0 ? newArr[0]["name"] : "No Playlist";
      return newArr.length > 0 ? newArr[0] : { "name": "No Playlist" };
  }

    function getCollectionForPlaylist(playlistId) {
        var newArr = collections.filter(function (c) {
            return c["playlists"].flatMap((p) => p["playlistId"]).includes(playlistId);
        })

        return newArr.length > 0 ? newArr[0] : "No Collection";
    }

  const [showModal, setShowModal] = useState(false)
  const [showPlayer, setShowPlayer] = useState(false)
  const [muted, setMuted] = useState(true);
  const handleToggleMute = () => setMuted(current => !current);

  const handleOnCloseModal = () => setShowModal(false)
  const handleOnClosePlayer = () => setShowPlayer(false)

  const toggleModal = (bool, collection, episodeId) => {
    setSelectedCollection(collection)
    setSelectedEpisodeId(episodeId)
    setShowModal(bool)
    ////console.log("Button Clicked")
  }

  const togglePlayer = (bool) => {
    setShowPlayer(bool)
  }

  

  function getVideoFromURL() {
    const queryParameters = new URLSearchParams(window.location.search)
    const queryMediaId = queryParameters.get("media")
    ////console.log(queryMediaId);
    // 1. bool (true)
    // 2. get playlist for media
    // 3. get collection for playlist
    // 4. media id
    // test media id: 1_l58aroyf
    if ( queryMediaId ) {
      const playlist = getPlaylistForEpisode(queryMediaId)
      const collection = getCollectionForPlaylist(playlist.id)
      //console.log("Found media id in URL: " + queryMediaId)
      //console.log(playlist.id + " " + collection.name)
      toggleModal(true, getCollectionForPlaylist(getPlaylistForEpisode(queryMediaId).id), queryMediaId)
    } else {
      //console.log("No media id found in URL.")
    }
  }

  function getContentWithTag(keywordTag) {

       var newArr = media.filter(function (m) {
          //return m["tags"]?.includes(keywordTag) && (m["tags"]?.includes(bu) || m["tags"]?.includes("allbus"));
          return m["tags"]?.includes(keywordTag);
      });

      return newArr;
  }


  useEffect(() => {
    //startWidgetSession();
    if(isSignedIn) {
      //startWidgetSession();
      Providers.globalProvider.graph.client.api('me').get()
    .then(gotMe => {
      ////console.log(gotMe.mail);
      setCurrentUsername(gotMe.mail);
      //startWidgetSession();
    });
    }
    if (!playlists) {
      //console.log('No Playlists!');
    }
    ////console.log(playlists.length + ' playlists');
    if (!media) {
       console.log('No Media!');
    }
    ////console.log(media.length + ' media');
    //getNewContent();
    ////console.log('sha1: ' + sha1(appTokenValue));
    //getVideoFromURL();
    //getPopularVideos();
  }, [isSignedIn]);

  useEffect(() => {
    if (playlists.length > 0 && media.length > 0) {
      getVideoFromURL();
      //console.log(playlists.length + " Playlists, " + media.length + " Media.")
      getTopVideos(kalturaSession);
    }
    //getCollectionContent();
  }, [playlists, media])

  useEffect(() => {
    ////console.log("currentUserName changed to " + currentUsername + ", starting widget session.");
    startWidgetSession();
  }, [currentUsername]);

  if (isSignedIn) {
    //console.log('Yes, user IS SIGNED IN')
    Providers.globalProvider.graph.client.api('me').get()
    .then(gotMe => {
      //console.log(gotMe.mail);
    });
    ////console.log(testMe);
    return (
    <div className="App bg-zinc-900">
        <div className="static flex bg-zinc-900">
            <HeroVideo />
            <div className="absolute z-30 w-full h-full flex items-center p-10">
            <div className="grid grid-cols-1 gap-10">
                {/* <h1 className="text-6xl sm:text-2xl text-white font-bold">Find Your Value Wedge</h1> */}
                <div className="inline flex gap-5">
                {/* <a href="/play"><HeroPlayButton togglePlayer={togglePlayer} /></a>
                <HeroInfoButton toggleModal={toggleModal} /> */}
                {/* <button onClick={handleToggleMute} className="control">Unmute</button> */}
                </div>
            </div>
            </div>
        </div>

        <div className="static grid grid-cols-1 2xl:gap-10 gap-4 z-40 2xl:-mt-96 -mt-80 absolute">
          {/* <NewSwimLane kalturaSession={kalturaSession} name="Latest Episodes" toggleModal={toggleModal} index="1" />
          <PopularSwimLane kalturaSession={kalturaSession} name="Most Popular" toggleModal={toggleModal} index="2" />
          <OriginalSeries name="Original Series" index="3" /> */}
          {/* { getContentWithTag("close strong fy25").length > 0 ? <SwimLaneFiltered kalturaSession={kalturaSession} name="FY26 Kickoff" playlists={playlists} media={getContentWithTag("close strong fy25")} toggleModal={toggleModal} index="15" /> : <br /> } */}
          
          { playlists.length > 0 && media.length > 0 ? <SwimLaneOriginalSeries kalturaSession={kalturaSession} name="Original Series" toggleModal={toggleModal} playlists={playlists} index="0" /> : <SwimLaneEmptyState name="Original Series" /> }

          { playlists.length > 0 && media.length > 0 ? <SwimLaneFiltered kalturaSession={kalturaSession} name="Recently Added" playlists={playlists} media={getNewContent()} toggleModal={toggleModal} index="1" /> : <SwimLaneEmptyState name="Recently Added" /> }

          { topVideos.length > 0 ? <SwimLaneFiltered kalturaSession={kalturaSession} name="Popular" playlists={playlists} media={topVideos} toggleModal={toggleModal} index="2" /> : <SwimLaneEmptyState name="Popular" /> }
          
          {/* { playlists.length > 0 && media.length > 0 ? <SwimLane kalturaSession={kalturaSession} name="Senior Leader Top Picks" playlist={getPlaylistWithId('1_4wlpkuxp')} media={getPlaylistContent(getPlaylistWithId('1_4wlpkuxp')["playlistContent"])} toggleModal={toggleModal} index="16" /> : <SwimLaneEmptyState name="Senior Leader Top Picks" /> } */}
          { playlists.length > 0 && media.length > 0 ? <SwimLane kalturaSession={kalturaSession} name="Sales Learning Plus Live" playlist={getPlaylistWithId('1_4rfxn3hl')} media={getPlaylistContent(getPlaylistWithId('1_4rfxn3hl')["playlistContent"])} toggleModal={toggleModal} index="20" /> : <SwimLaneEmptyState name="Sales Learning Plus Live" /> }
          
          
          { getContentWithTag("comp intel").length > 0 ? <SwimLaneFiltered kalturaSession={kalturaSession} name="Competitive Intelligence" playlists={playlists} media={getContentWithTag("comp intel")} toggleModal={toggleModal} index="10" /> : <br /> }
          { getContentWithTag("product").length > 0 ? <SwimLaneFiltered kalturaSession={kalturaSession} name="Product" playlists={playlists} media={getContentWithTag("product")} toggleModal={toggleModal} index="11" /> : <br /> }
          { getContentWithTag("selling skills").length > 0 ? <SwimLaneFiltered kalturaSession={kalturaSession} name="Selling Skills" playlists={playlists} media={getContentWithTag("selling skills")} toggleModal={toggleModal} index="12" /> : <br /> }
          { getContentWithTag("messaging").length > 0 ? <SwimLaneFiltered kalturaSession={kalturaSession} name="Messaging" playlists={playlists} media={getContentWithTag("messaging")} toggleModal={toggleModal} index="13" /> : <br /> }
          { getContentWithTag("tools").length > 0 ? <SwimLaneFiltered kalturaSession={kalturaSession} name="Tools" playlists={playlists} media={getContentWithTag("tools")} toggleModal={toggleModal} index="14" /> : <br /> }
          { getContentWithTag("business acumen").length > 0 ? <SwimLaneFiltered kalturaSession={kalturaSession} name="Business Acumen" playlists={playlists} media={getContentWithTag("business acumen")} toggleModal={toggleModal} index="15" /> : <br /> }
          { getContentWithTag("hear from a peer").length > 0 ? <SwimLaneFiltered kalturaSession={kalturaSession} name="Hear from a Peer" playlists={playlists} media={getContentWithTag("hear from a peer")} toggleModal={toggleModal} index="16" /> : <br /> }

          {/* <SwimLane kalturaSession={kalturaSession} name="CI on the Fly" playlistId="1_sxzohcku" toggleModal={toggleModal} index="5" />
          <SwimLane kalturaSession={kalturaSession} name="HiPer Curious" playlistId="1_1sa9fr0z" toggleModal={toggleModal} index="6" />
          <SwimLane kalturaSession={kalturaSession} name="Tool Talk" playlistId="1_z1oh8ikk" toggleModal={toggleModal} index="7" /> */}
          {/* <CollectionCarousel title="Continue Watching" toggleModal={toggleModal} />
          <CollectionOriginalSeries title="Original Series" toggleModal={toggleModal} />
          <CollectionCarousel title="Latest Episodes" toggleModal={toggleModal} />
          <CollectionCarousel title="Recommended" toggleModal={toggleModal} />
          <CollectionCarousel title="Watch It Again" toggleModal={toggleModal} /> */}
          <div className="absolute w-full h-full flex items-start -z-10">
            <div className="bg-gradient-to-t from-zinc-900 via-zinc-900 h-96 w-screen">
              
            </div>
          </div>
          <HomeFooter />
        </div>
      <ModalVideoInfo onClose={handleOnCloseModal} visible={showModal} kalturaSession={kalturaSession} collection={selectedCollection} media={media} playlists={playlists} episodeId={selectedEpisodeId} />
    </div>
  );
  }

  return (
    <>
      <div id="container" className="fixed inset-0 flex justify-center items-center gap-4">
        <img src="slplogowhite.png" className="h-8" />
        <div className="grid grid-cols-1 flex justify-center items-center mgt-light rounded">
          {/* <h1 className="text-2xl text-white text-bold">Please sign in with SSO to access SL+</h1> */}
          <header>
            <Login />
          </header>
        </div>
      </div>
    </>
  )
}

export default Home;